import { makeAutoObservable } from "mobx";
// Request
import { InternalDocumentRequest } from "../requests/InternalDocumentRequest";
import { ASSIGNEE_TYPE } from "../utils/constants";
import { clone } from "lodash";

class InternalDocumentStore {
  /**Incoming Document**/
  internalDocumentIncomingList = [];
  internalDocumentIncomingListAll = [];
  internalDocumentIncomingListTotalPage = undefined;
  internalDocumentIncomingListTotalCount = undefined;
  internalDocumentIncomingListPageIndex = 0;
  selectedInternalDocumentIncoming = {};
  internalDocumentCommentList = [];
  internalDocumentCommentListSortByDatePost = "ASC";
  selectedInternalDocumentIncomingAttachment = undefined;
  viewLogList = [];
  defaultQueryParamsInDoc = {
    page: 0,
    size: 10,
  };
  defaultQueryParamsOutDoc = {
    page: 0,
    size: 10,
  };
  constructor() {
    makeAutoObservable(this);
  }
  clear = () => {
    this.internalDocumentIncomingList.length = 0;
    this.internalDocumentOutgoingList.length = 0;
    this.internalDocumentIncomingListTotalCount = 0;
    this.internalDocumentOutgoingListTotalCount = 0;
    this.defaultQueryParamsOutDoc = {
      page: 0,
      size: 10,
    };
    this.defaultQueryParamsInDoc = {
      page: 0,
      size: 10,
    };
  };
  clearInternalDocumentIncomingList = () => {
    this.internalDocumentIncomingList.length = 0;
    this.internalDocumentCommentList.length = 0;
  };
  clearSelectedInternalDocumentIncoming = () => {
    this.selectedInternalDocumentIncoming = {};
    this.selectedInternalDocumentIncomingAttachment = undefined;
  };
  clearInternalDocumentIncomingListFilter = () => {
    this.internalDocumentIncomingListPageIndex = 0;
  };

  setQueryParamsIncoming = (payload) => {
    this.queryParamsIncoming = {
      ...payload,
      size: payload.size ? parseInt(payload.size) : 10,
      page: payload.page ? parseInt(payload.page) : 0,
    };
  };
  setViewLogList = (payload) => {
    this.viewLogList = payload;
  };

  getWarningDocumentNumber = (book_id, document_number, type) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getWarningDocumentNumber(
        book_id,
        document_number,
        type
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  suggestIncomingNumber = (book_id) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.suggestIncomingNumber(book_id)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };
  queryParams = clone(this.defaultQueryParamsInDoc);
  clearQueryParams = () => {
    this.queryParams = clone(this.defaultQueryParamsInDoc);
  };
  setQueryParamsInDoc = (payload) => {
    this.defaultQueryParamsInDoc = payload;
  };
  setQueryParamsOutDoc = (payload) => {
    this.defaultQueryParamsOutDoc = payload;
  };
  getInternalDocumentIncomingList = (params) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentIncomingList(params)
        .then((response) => {
          this.internalDocumentIncomingList = [
            ...this.internalDocumentIncomingList,
            ...response.data.data,
          ];
          this.internalDocumentIncomingListTotalPage = response.data.total_page;
          this.internalDocumentIncomingListTotalCount =
            response.data.total_count;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  getInternalDocumentIncomingListAll = () => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentIncomingList({
        ...this.queryParamsIncoming,
        page: 0,
        size: 10000,
      })
        .then((response) => {
          this.internalDocumentIncomingListAll = response.data.data;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getForExportInternalDocumentIncomingListAll = () => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getForExportInternalDocumentIncomingList({
        ...this.queryParamsIncoming,
        page: 0,
        size: 10000,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  createInternalDocumentIncoming = (documentInfo) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.createInternalDocumentIncoming(documentInfo)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  updateInternalDocument = (id, documentInfo) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.updateInternalDocument(id, documentInfo)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  // user_assigneds
  userAssignList = [];
  departmentAssignList = [];
  groupAssignList = [];

  convertListToDefault = (originList) => {
    return originList.map((el) => ({
      full_name: el.name_uppercase ? el.name_uppercase : "",
      id: el.assignee_code,
      image_id: el.image,
      assignee_type: el.assignee_type,
      permission: el.permission,
      last_date_read: el.last_date_read,
    }));
  };

  handlerAssignList = [];
  combinerAssignList = [];
  followerAssignList = [];
  signerAssign = null;

  clearAssignList = () => {
    this.userAssignList = [];
    this.departmentAssignList = [];
    this.groupAssignList = [];
    this.handlerAssignList = [];
    this.combinerAssignList = [];
    this.followerAssignList = [];
  };
  getInternalDocumentIncomingById = (docId) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentIncomingById(docId)
        .then((response) => {
          this.selectedInternalDocumentIncoming = response.data;
          const user_assigneds = response.data.user_assigneds;
          this.userAssignList =
            user_assigneds?.filter(
              (el) =>
                el.assignee_type === ASSIGNEE_TYPE.USER &&
                el.permission !== ASSIGNEE_TYPE.CREATE
            ) || [];
          this.departmentAssignList =
            user_assigneds?.filter(
              (el) => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT
            ) || [];
          this.groupAssignList =
            user_assigneds?.filter(
              (el) =>
                el.assignee_type === ASSIGNEE_TYPE.GROUP &&
                el.permission !== ASSIGNEE_TYPE.CREATE
            ) || [];
          this.handlerAssignList = this.convertListToDefault(
            user_assigneds?.filter(
              (el) => el.permission === ASSIGNEE_TYPE.HANDLER
            ) || []
          );
          this.combinerAssignList = this.convertListToDefault(
            user_assigneds?.filter(
              (el) => el.permission === ASSIGNEE_TYPE.COMBINER
            ) || []
          );
          this.followerAssignList = this.convertListToDefault(
            user_assigneds?.filter(
              (el) => el.permission === ASSIGNEE_TYPE.FOLLOWER
            ) || []
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  deleteIncomingInternalDocumentById = (docId) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.deleteIncomingInternalDocumentById(docId)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  createInternalDocumentComment = (internal_document_code, data) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.createInternalDocumentComment(
        internal_document_code,
        data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  setinternalDocumentCommentListSortByDatePost = (sort) => {
    this.internalDocumentCommentListSortByDatePost = sort;
  };
  getInternalDocumentComment = (internal_document_code) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentComment(
        internal_document_code
        // this.internalDocumentCommentListSortByDatePost,
      )
        .then((response) => {
          this.internalDocumentCommentList = response.data;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  clearInternalDocumentCommentList = () => {
    this.internalDocumentCommentList.length = 0;
  };
  getSelectedInternalDocumentAttachment = (internal_document_code, file_id) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getSelectedInternalDocumentAttachment(
        internal_document_code,
        file_id
      )
        .then((response) => {
          this.selectedInternalDocumentIncomingAttachment = response.data;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  deleteInternalDocumentComment = (internal_document_code, comment_id) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.deleteInternalDocumentComment(
        internal_document_code,
        comment_id
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  createInternalDocumentIncomingAssignUser = (documentId, submitValues) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.createInternalDocumentIncomingAssignUser(
        documentId,
        submitValues
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  updateInternalDocumentIncomingAssignUser = (documentId, submitValues) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.updateInternalDocumentIncomingAssignUser(
        documentId,
        submitValues
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  deleteInternalDocumentIncomingAssignUser = (documentId, submitValues) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.deleteInternalDocumentIncomingAssignUser(
        documentId,
        submitValues
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  updateInternalDocumentIncomingStatus = (internal_document_id) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.updateInternalDocumentIncomingStatus(
        internal_document_id
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  /**Outgoing Document**/
  internalDocumentOutgoingList = [];
  internalDocumentOutgoingListAll = [];
  internalDocumentOutgoingListTotalPage = undefined;
  internalDocumentOutgoingListTotalCount = undefined;
  internalDocumentOutgoingListPageIndex = 0;
  selectedInternalDocumentOutgoing = {};
  selectedInternalDocumentOutgoingAttachment = undefined;

  clearInternalDocumentOutgoingList = () => {
    this.internalDocumentOutgoingList.length = 0;
  };
  clearSelectedInternalDocumentOutgoing = () => {
    this.selectedInternalDocumentOutgoing = {};
    this.selectedInternalDocumentOutgoingAttachment = undefined;
  };
  clearInternalDocumentOutgoingListFilter = () => {
    this.internalDocumentOutgoingListPageIndex = 0;
  };

  getInternalDocumentOutgoingList = (param) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentOutgoingList(param)
        .then((response) => {
          this.internalDocumentOutgoingList = [
            ...this.internalDocumentOutgoingList,
            ...response.data.data,
          ];
          this.internalDocumentOutgoingListTotalPage = response.data.total_page;
          this.internalDocumentOutgoingListTotalCount =
            response.data.total_count;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  deleteOutgoingInternalDocumentById = (docId) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.deleteOutgoingInternalDocumentById(docId)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  createInternalDocumentOutgoing = (documentInfo) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.createInternalDocumentOutgoing(documentInfo)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  getInternalDocumentOutgoingById = (docId) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentOutgoingById(docId)
        .then((response) => {
          const user_assigneds = response.data.user_assigneds;
          this.userAssignList =
            user_assigneds?.filter(
              (el) =>
                el.assignee_type === ASSIGNEE_TYPE.USER &&
                el.permission !== ASSIGNEE_TYPE.CREATE &&
                el.permission !== ASSIGNEE_TYPE.SIGNER
            ) || [];
          this.departmentAssignList =
            user_assigneds?.filter(
              (el) => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT
            ) || [];
          this.groupAssignList =
            user_assigneds?.filter(
              (el) =>
                el.assignee_type === ASSIGNEE_TYPE.GROUP &&
                el.permission !== ASSIGNEE_TYPE.CREATE
            ) || [];
          this.followerAssignList = this.convertListToDefault(
            user_assigneds?.filter(
              (el) => el.permission === ASSIGNEE_TYPE.FOLLOWER
            ) || []
          );
          this.signerAssign = this.convertListToDefault(
            user_assigneds?.filter(
              (el) => el.permission === ASSIGNEE_TYPE.SIGNER
            ) || null
          );
          this.selectedInternalDocumentOutgoing = response.data;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  getSelectedInternalDocumentOutgoingAttachment = (
    internal_document_code,
    file_id
  ) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getSelectedInternalDocumentOutgoingAttachment(
        internal_document_code,
        file_id
      )
        .then((response) => {
          this.selectedInternalDocumentOutgoingAttachment = response.data;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  updateOutgoingInternalDocumentFollower = (documentCode, followerList) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.updateOutgoingInternalDocumentFollower(
        documentCode,
        followerList
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  changeOutgoingInternalDocumentFollower = (documentCode, followerList) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.changeOutgoingInternalDocumentFollower(
        documentCode,
        followerList
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };
  changeIncomingInternalDocumentFollower = (documentCode, followerList) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.changeIncomingInternalDocumentFollower(
        documentCode,
        followerList
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  eSignDocument = (formData) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.eSignDocument(formData)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== "string") return;
    this[filterName] = filterValue;
  };

  updateAssignees = (documentCode, data) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.updateAssignees(documentCode, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  getViewLog = (params) => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getViewLog(params)
        .then((response) => {
          this.viewLogList = [
            ...this.viewLogList,
            ...response.data.data.map((item) => ({
              ...item,
              groupId: params.assignee_code,
              groupType: params.assignee_type,
            })),
          ];
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  /**document system*/

  // Incoming
  internalDocumentIncomingSystemList = [];
  internalDocumentIncomingSystemTotal = 0;
  internalDocumentIncomingSystemPageIndex = 0;
  internalDocumentIncomingSystemPageSize = 10;
  internalDocumentIncomingSystemFilterByKeyword = null;
  // Outgoing
  internalDocumentOutgoingSystemList = [];
  internalDocumentOutgoingSystemTotal = 0;
  internalDocumentOutgoingSystemPageIndex = 0;
  internalDocumentOutgoingSystemPageSize = 10;
  internalDocumentOutgoingSystemFilterByKeyword = null;

  getInternalDocumentIncomingSystemList = () => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentIncomingSystemList({
        page: this.internalDocumentIncomingSystemPageIndex,
        size: this.internalDocumentIncomingSystemPageSize,
        keyword: this.internalDocumentIncomingSystemFilterByKeyword,
      })
        .then((response) => {
          this.internalDocumentIncomingSystemList = response.data.data;
          this.internalDocumentIncomingSystemTotal = response.data.total_count;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  clearInternalDocumentIncomingSystem = () => {
    this.internalDocumentIncomingSystemList = [];
    this.internalDocumentIncomingSystemTotal = 0;
    this.internalDocumentIncomingSystemPageIndex = 0;
    this.internalDocumentIncomingSystemPageSize = 10;
    this.internalDocumentIncomingSystemFilterByKeyword = null;
    this.viewLogList = [];
  };

  getInternalDocumentOutgoingSystemList = () => {
    return new Promise((resolve, reject) => {
      InternalDocumentRequest.getInternalDocumentOutgoingSystemList({
        page: this.internalDocumentOutgoingSystemPageIndex,
        size: this.internalDocumentOutgoingSystemPageSize,
        keyword: this.internalDocumentOutgoingSystemFilterByKeyword,
      })
        .then((response) => {
          this.internalDocumentOutgoingSystemList = response.data.data;
          this.internalDocumentOutgoingSystemTotal = response.data.total_count;
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  clearInternalDocumentOutgoingSystem = () => {
    this.internalDocumentOutgoingSystemList = [];
    this.internalDocumentOutgoingSystemTotal = 0;
    this.internalDocumentOutgoingSystemPageIndex = 0;
    this.internalDocumentOutgoingSystemPageSize = 10;
    this.internalDocumentOutgoingSystemFilterByKeyword = null;
  };
}
const internalDocumentStore = new InternalDocumentStore();
export default internalDocumentStore;
